import { defineComponent, h } from 'vue';
import { QBtn, QDialog, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

function getMenus(menu) {
    let items = [menu.element];
    for (let i = 0; i < menu.children.length; i++)
        items = [...items, ...getMenus(menu.children[i])];

    return items;
}
function findParentMenu(parent, path) {
    let targetname = path;
    if (path.includes('::'))
        targetname = path.split('::')[0];

    const menu = parent.find(m => m.name === targetname);
    if (!menu)
        return null;

    if (path.includes('::')) {
        const index = path.indexOf('::');
        targetname = path.substr(index + 2);
        return findParentMenu(menu.children, targetname);
    }
    return menu;
}
function addPlusButton(context, level, menus) {
    for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu.children.length > 0) {
            const lastchild = menu.children[menu.children.length - 1];
            let lastindex = '0';
            let menupath = '';
            if (lastchild.menu) {
                lastindex = lastchild.menu.Index;
                menupath = lastchild.menu.MenuPath;
            }

            const next_index = parseInt(lastindex, 10) + 1;

            menu.children.push({
                menu: null,
                name: '',
                element: (
                    <tr>
                        <td colSpan={4} style={{ width: '100%', borderBottom: '1px solid silver' }}>
                            <span style={{ paddingLeft: (15 + 30 * level) + 'px' }}>
                                <i
                                    class="mdi mdi-plus"
                                    title={'Add Submenu Item to ' + menu.name + ' after index ' + lastindex}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => context.addChildMenuItem(e, next_index, menupath)}
                                />
                            </span>
                        </td>
                    </tr>
                ),
                children: [],
            });

            addPlusButton(context, level + 1, menu.children);
        }
        else if (menu.menu && (!menu.menu.MenuItemData.ControlData || !menu.menu.MenuItemData.ControlData.Controls || menu.menu.MenuItemData.ControlData.Controls.length == 0)) {
            let menupath = menu.menu.MenuPath || '';
            if (menupath) menupath += '::';
            menupath += menu.menu.MenuItemData.Title;

            const next_index = menu.menu.Index + '1';

            menu.children.push({
                menu: null,
                name: '',
                element: (
                    <tr>
                        <td colSpan={4} style={{ width: '100%', borderBottom: '1px solid silver' }}>
                            <span style={{ paddingLeft: (15 + 30 * level) + 'px' }}>
                                <i
                                    class="mdi mdi-plus"
                                    title={'Add Submenu Item to ' + menu.name}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => context.addChildMenuItem(e, next_index, menupath)}
                                />
                            </span>
                        </td>
                    </tr>
                ),
                children: [],
            });
        }
    }
}
function getPreviousTopMenu(index, childMenus) {
    index--;
    while (index >= 0) {
        const menu = childMenus[index];
        if (!menu.MenuPath) return menu;
        index--;
    }
    return null;
}
function getNextTopMenu(index, childMenus) {
    index++;
    while (index < childMenus.length) {
        const menu = childMenus[index];
        if (!menu.MenuPath) return menu;
        index++;
    }
    return null;
}
function getPreviousChildMenu(menuPath, index, childMenus) {
    let menu;
    for (let i = 0; i < childMenus.length; i++) {
        if (childMenus[i].MenuPath == menuPath) {
            if (childMenus[i].Index == index && menu) return menu;
            menu = childMenus[i];
        }
    }
    return null;
}
function getNextChildMenu(menuPath, index, childMenus) {
    let menu;
    for (let i = 0; i < childMenus.length; i++) {
        if (childMenus[i].MenuPath == menuPath) {
            if (childMenus[i].Index == index && !menu)
                menu = childMenus[i];
            else if (menu)
                return childMenus[i];
        }
    }
    return null;
}

export default defineComponent({
    name: 'carecenter-menu-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QBtn,
        QDialog,
        QTooltip,
        ControlPicker,
    },
    data() {
        return {
            childMenus: null,
            deleteEnabled: false,
        };
    },
    created() {
        if (this.designmodel && this.designmodel._id) {
            this.$watch('designmodel._id', () => {
                if ((!this.controlData || !this.controlData.Controls || this.controlData.Controls.length === 0) && this.designmodel.MenuItemData.ChildMenuType)
                    this.RefreshChildMenus();
                else
                    this.childMenus = null;
            });
        }
    },
    mounted() {
        if ((!this.controlData || !this.controlData.Controls || this.controlData.Controls.length === 0) && this.designmodel.MenuItemData.ChildMenuType)
            this.RefreshChildMenus();
        else
            this.childMenus = null;
    },
    methods: {
        async RefreshChildMenus() {
            switch (this.designmodel.MenuItemData.ChildMenuType) {
                case 'MenuName':
                    this.childMenus = await utils.api.get('Apps/MenuItems/ListAll/' + this.designmodel.MenuItemData.ChildMenuName);
                    break;

                case 'URL':
                    this.childMenus = await utils.api.get(this.designmodel.MenuItemData.ChildMenuURL);
                    break;

                case 'PopupMenu':
                    this.childMenus = await utils.api.get('Apps/MenuItems/ListAll/' + this.designmodel.MenuItemData.PopupMenuName);
                    break;

                default:
                    return;
            }
            this.childMenus.sort((a, b) => a.Index - b.Index);
        },
        jumpToMenu(e, menu) {
            this.childMenus = null;
            this.Root.ExternalNavigate('Apps/UI/MenuItem/' + menu._id);

            e.cancelBubble = true;
            e.stopPropagation();
        },
        addChildMenuItem(e, index, path) {
            this.childMenus = null;
            let url = 'Apps/SchemaBootstrap/NewEmptyDocument/MenuChild/';
            url += '?MenuName=' + this.designmodel.MenuItemData.ChildMenuName;
            url += '&MenuIndex=' + index;
            url += '&MenuPath=' + (path || '');
            url += '&uuid=' + utils.generateUUID();

            this.Root.ExternalNavigate(url);

            e.cancelBubble = true;
            e.stopPropagation();
        },
        async swapMenuIndexes(e, menu1, menu2) {
            const url = 'Apps/UI/SwapMenuItemIndexes/' + menu1._id + '/' + menu2._id;
            const res = await utils.api.get(url);
            if (res.Menu1.Success.Success && res.Menu2.Success.Success)
                this.RefreshChildMenus();
            else
                alert(JSON.stringify(res, null, 4));
        },
        async deleteMenu(e, menu) {
            const url = 'Apps/UI/MenuItem/' + menu._id;
            const res = await utils.api.request('DELETE', url);
            if (res === true)
                this.RefreshChildMenus();
            else
                alert(JSON.stringify(res, null, 4));
        },
        toggleDeleteEnabled(e) {
            this.deleteEnabled = !this.deleteEnabled;
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: { type: String, default: '' },
        root: { type: Object, default: null },
        designmodel: { type: Object, default: null },
        controlData: { type: Object, default: () => ({}) },
    },
    render() {
        let icontitle;
        if (this.designmodel.MenuItemData.Icon && this.designmodel.MenuItemData.Icon.Icon)
            icontitle = (
                <span style={{ fontSize: 'x-large' }}>
                    <i title={this.designmodel.MenuItemData.Icon.Tooltip} class={this.designmodel.MenuItemData.Icon.Icon} /> {this.designmodel.MenuItemData.Title}
                </span>
            );
        else if (this.designmodel.MenuItemData.Icon)
            icontitle = (
                <span style={{ fontSize: 'x-large' }}>
                    <i title={this.designmodel.MenuItemData.Icon.Tooltip} class={this.designmodel.MenuItemData.Icon} /> {this.designmodel.MenuItemData.Title}
                </span>
            );
        else
            icontitle = (
                <span style={{ fontSize: 'x-large' }}>
                    <i title="Undefined" class="mdi mdi-help-circle" /> {this.designmodel.MenuItemData.Title}
                </span>
            );

        if (this.childMenus) {
            const menus = [];

            const style = {
                textDecoration: 'underline',
                cursor: 'pointer',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                padding: '5px 15px 5px 15px',
                width: '300px',
            };

            for (let i = 0; i < this.childMenus.length; i++) {
                const menu = this.childMenus[i];
                let icon;
                if (menu.MenuItemData.Icon)
                    icon = <i class={menu.MenuItemData.Icon.Icon} />;

                let label = menu.MenuItemData.Title;
                let menuname;
                if (menu.MenuItemData.Name)
                    menuname = <span style={{ color: 'gray' }}>({menu.MenuItemData.Name})</span>;

                if (menu.MenuPath) continue;

                const lastmenu = getPreviousTopMenu(i, this.childMenus);
                const nextmenu = getNextTopMenu(i, this.childMenus);

                let moveUp;
                let moveDown;
                let deleteicon;
                if (lastmenu)
                    moveUp = <i class="mdi mdi-menu-up simple_link" title="Move Up" onClick={(e) => this.swapMenuIndexes(e, menu, lastmenu)} />;
                if (nextmenu)
                    moveDown = <i class="mdi mdi-menu-down simple_link" title="Move Down" onClick={(e) => this.swapMenuIndexes(e, menu, nextmenu)} />;
                if (this.deleteEnabled)
                    deleteicon = <i class="mdi mdi-close simple_link" onClick={(e) => this.deleteMenu(e, menu)} title="Delete" />;

                menus.push({
                    menu: menu,
                    name: menu.MenuItemData.Title,
                    element: (
                        <tr key={menu._id}>
                            <td style={{ width: '100%', borderBottom: '1px solid silver' }}>
                                <span
                                    title="Edit Menu"
                                    style={style}
                                    onClick={(e) => this.jumpToMenu(e, menu)}>
                                    {icon} {label} {menuname}
                                </span>
                            </td>
                            <td style={{ whiteSpace: 'nowrap', fontSize: 'smaller', borderBottom: '1px solid silver', paddingRight: '5px', alignItems: 'right' }}>
                                {menu.Role}
                            </td>
                            <td style={{ whiteSpace: 'nowrap', fontSize: 'smaller', borderBottom: '1px solid silver' }}>
                                {deleteicon} [{menu.Index}]
                            </td>
                            <td style={{ borderBottom: '1px solid silver' }}>
                                <span style={{ whiteSpace: 'nowrap', color: 'gray', marginLeft: '10px' }}>
                                    {moveUp} {moveDown}
                                </span>
                            </td>
                        </tr>
                    ),
                    children: [],
                });
            }
            let lastindex_top = '0';
            if (menus.length > 0) {
                const lastmenu = menus[menus.length - 1];
                lastindex_top = lastmenu.menu.Index;
            }
            const next_index = parseInt(lastindex_top, 10) + 1;
            menus.push({
                menu: null,
                name: '',
                element: (
                    <tr>
                        <td colSpan={4}>
                            <span style={{ paddingLeft: '15px' }}>
                                <i
                                    class="mdi mdi-plus"
                                    title={'Add Top Level Menu Item after index ' + lastindex_top}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => this.addChildMenuItem(e, next_index)}
                                />
                            </span>
                        </td>
                    </tr>
                ),
                children: [],
            });

            for (let i = 0; i < this.childMenus.length; i++) {
                const menu = this.childMenus[i];
                let icon;
                if (menu.MenuItemData.Icon)
                    icon = <i class={menu.MenuItemData.Icon.Icon} />;

                let label = menu.MenuItemData.Title;
                let menuname;
                if (menu.MenuItemData.Name)
                    menuname = <span style={{ color: 'gray' }}>({menu.MenuItemData.Name})</span>;

                if (menu.MenuPath) {
                    const parent = findParentMenu(menus, menu.MenuPath);
                    if (parent) {
                        const lastmenu = getPreviousChildMenu(menu.MenuPath, menu.Index, this.childMenus);
                        const nextmenu = getNextChildMenu(menu.MenuPath, menu.Index, this.childMenus);

                        let moveUp;
                        let moveDown;
                        let deleteicon;
                        if (lastmenu)
                            moveUp = <i class="mdi mdi-menu-up simple_link" title="Move Up" onClick={(e) => this.swapMenuIndexes(e, menu, lastmenu)} />;
                        if (nextmenu)
                            moveDown = <i class="mdi mdi-menu-down simple_link" title="Move Down" onClick={(e) => this.swapMenuIndexes(e, menu, nextmenu)} />;
                        if (this.deleteEnabled)
                            deleteicon = <i class="mdi mdi-close simple_link" onClick={(e) => this.deleteMenu(e, menu)} title="Delete" />;

                        const count = (menu.MenuPath.match(/::/g) || []).length + 1;
                        parent.children.push({
                            menu: menu,
                            name: menu.MenuItemData.Title,
                            element: (
                                <tr key={menu._id}>
                                    <td style={{ width: '100%', borderBottom: '1px solid silver' }}>
                                        <span
                                            title="Edit Menu"
                                            style={{ ...style, paddingLeft: (15 + 30 * count) + 'px' }}
                                            onClick={(e) => this.jumpToMenu(e, menu)}>
                                            {icon} {label} {menuname}
                                        </span>
                                    </td>
                                    <td style={{ whiteSpace: 'nowrap', fontSize: 'smaller', borderBottom: '1px solid silver', paddingRight: '5px', alignItems: 'right' }}>
                                        {menu.Role}
                                    </td>
                                    <td style={{ whiteSpace: 'nowrap', fontSize: 'smaller', borderBottom: '1px solid silver' }}>
                                        {deleteicon} [{menu.Index}]
                                    </td>
                                    <td style={{ borderBottom: '1px solid silver' }}>
                                        <span style={{ whiteSpace: 'nowrap', color: 'gray', marginLeft: '10px' }}>
                                            {moveUp} {moveDown}
                                        </span>
                                    </td>
                                </tr>
                            ),
                            children: [],
                        });

                        continue;
                    }
                    else
                        label = [menu.MenuPath, <i class="mdi mdi-menu-right" style={{ marginLeft: '3px', marginRight: '3px' }} />, label];
                }
            }

            addPlusButton(this, 1, menus);

            let allmenus = [];
            for (let i = 0; i < menus.length; i++)
                allmenus = [...allmenus, ...getMenus(menus[i])];

            const tablestyle = {
                margin: '10px',
                padding: '10px',
                borderStyle: 'solid',
                borderColor: 'black',
                borderWidth: '1px',
                borderRadius: '8px',
            };

            return (
                <div
                    class={{ 'designer-container': true, selected: this.selected$ }}
                    style={tablestyle}
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                    <div
                        class="design-options"
                        onClick={(e) => this.toggleDeleteEnabled(e)}
                        style={{ top: '4px', right: '4px', display: this.selected$ ? 'block' : 'none' }}>
                        {this.deleteEnabled ? 'Cancel' : 'Delete Items'}
                    </div>

                    {icontitle}
                    <table style={{ borderCollapse: 'collapse', border: '1px solid silver' }}>
                        {allmenus}
                    </table>
                </div>
            );
        }
        else if (!this.controlData || !this.controlData.Controls)
            return null;

        const items = [];

        if (this.selected$ || (this.controlData.HeaderControls && this.controlData.HeaderControls.length > 0)) {
            utils.getHeaderControls(h, this.controlData, items, this.root, 'ControlContainer', this.addControl, this.selected$);
        }

        for (let i = 0; i < this.controlData.Controls.length; i++) {
            const control = this.controlData.Controls[i];
            if (typeof control !== 'object')
                continue;

            let DynamicControl = utils.getDesignerComponent(control, null);

            if (!control.$objectId) control.$objectId = utils.generateUUID();

            items.push(
                <DynamicControl
                    key={control.$objectId}
                    type={control.ControlType}
                    name={control.ControlData ? control.ControlData.Name : ''}
                    root={this.root}
                    designmodel={control}
                    parentType="VerticalLayout"
                    controlData={control.ControlData}
                    controlURL={control.ControlURL}
                    sourceIndex={i}
                />
            );
        }

        if (this.selected$) {
            items.push(
                <div class="property-grid" key="add-body">
                    <QBtn size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 992 }} onClick={(e) => this.addControl(e, 'body')}>
                        <QTooltip>Add control to body</QTooltip>
                    </QBtn>
                </div>
            );
        }

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData.SizeOptions) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                {icontitle}
                {this.name}<br />
                {items}

                {this.generatePicker(h)}
            </div>
        );
    },
});
